import React from 'react';
import { IAttributionItem } from '../../../app/types/filter';

// ==================== Интерфейсы ====================

export interface SelectValue {
    name: string;
    id: string;
    icon: React.ReactElement | null;
    default?: boolean;
}

export interface AttributionItem {
    id: string;
    name: string;
    selectValues: SelectValue[];
    description: string;
    icon: React.ReactElement | null;
}

// ==================== Константы атрибуции ====================

/**
 * Общие элементы атрибуции для всех отчётов
 * Используется в: OrderReports, PaymentReports, Visits, ADReports
 */
export const ATTR_ITEMS: AttributionItem[] = [
    {
        id: 'type_applications',
        name: 'Тип регистрации:',
        selectValues: [
            { name: 'Нулевые заказы GC', id: '2', icon: null },
            { name: 'Прямая продажа', id: '4', icon: null },
            { name: 'Регистрации GC', id: '0', icon: null },
            { name: 'SCAN', id: '1', icon: null },
        ],
        description: `Выбор типа регистрации по которым нужно создать отчёт:
                <br><br>
                Типы регистраци:
                <br><br>
                - SCAN - Это данные собираемые скриптом SCAN с форм;<br>
                - Прямая продажа - эта регистрация создаётся автоматически в SCANе при создании платного заказа. Название регистрации будет являться название платного предложения;<br>
                - Нулевые заказы GC - Заказы в GetCourse со стоимостью 0 руб.;<br>
                - Регистрации GC -  Первая регистрация (попадания в базу) в GetCourse;<br>
                <br><br>
                <a href="https://doc.scananalytics.ru/otchety/tip-registracii/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
                `,
        icon: null,
    },
    {
        id: 'attribution',
        name: 'Атрибуция:',
        selectValues: [
            { name: 'Первая регистрация', id: '1', icon: null },
            { name: 'Последняя регистрация', id: '2', icon: null },
        ],
        description: `Сервис SCAN позволяет определить к какой регистрации пользователя привязывать заказ. В сервисе 2 типа атрибуции:
                <br><br>
                - Первая регистрация <br>
                - Последняя регистрация <br>
                <br><br>
                <a href="https://doc.scananalytics.ru/otchety/atribuciya/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
                `,
        icon: null,
    },
];

// ==================== Функция для создания attrItems с иконками ====================

/**
 * Создаёт attrItems с иконками для использования в компонентах
 * Иконки передаются как параметры, чтобы избежать проблем с импортом SVG
 */
export const createAttrItems = (
    typeIcon: React.ReactElement | null,
    firstRegIcon: React.ReactElement | null,
    lastRegIcon: React.ReactElement | null
): IAttributionItem[] => [
    {
        ...ATTR_ITEMS[0],
        icon: typeIcon,
    },
    {
        ...ATTR_ITEMS[1],
        selectValues: [
            { name: 'Первая регистрация', id: '1', icon: firstRegIcon },
            { name: 'Последняя регистрация', id: '2', icon: lastRegIcon },
        ],
    },
];

// ==================== Константы инициализации отчётов ====================

export const REPORT_INIT_DELAYS = {
    ad: 50,
    order: 50,
    payment: 50,
    visit: 700,
    webinar: 50,
    universal: 50,
} as const;

export type ReportTypeKey = keyof typeof REPORT_INIT_DELAYS;

// ==================== Константы для таблиц ====================

export const TABLE_DEFAULTS = {
    COLUMN_WIDTH: 120,
    COLUMN_MIN_WIDTH: 120,
    COLUMN_MAX_WIDTH: 900,
    GROUP_COLUMN_MIN_WIDTH: 260,
    HEADER_HEIGHT: 110,
    CELL_HEIGHT: 38,
    TABLE_MIN_WIDTH: 1000,
    TABLE_MIN_HEIGHT: 300,
    TABLE_HEIGHT_OFFSET: 150,
} as const;

// ==================== Константы для графиков ====================

export const CHART_DEFAULTS = {
    MIN_HEIGHT: 300,
    ANIMATION_DURATION: 300,
} as const;
